<kendo-grid [data]="gridSettings.gridData"
            class="inHouseGridCls"
            [sortable]="true"
            [selectable]="false"
            [navigable]="true"
            [filterable]="true"
            [groupable]="false"
            [reorderable]="true"
            [resizable]="true"
            [sort]="gridSettings.state.sort"
            [pageable]="{ buttonCount: 5, info: true, pageSizes:[50,75,100] }"
            [pageSize]="gridSettings.state.take"
            [skip]="gridSettings.state.skip"
            [columnMenu]="{  filter: false, sort: false }"
            (sort)="inHouseGridSortChange($event)"
            (pageChange)="inHouseGridPageChange($event)"
            (dataStateChange)="inHouseDataStateChange($event)"
            (columnReorder)="onReorder($event)"
            (columnVisibilityChange)="onVisibilityChange($event)"
            (columnResize)="onResize($event)"
            [filter]="gridSettings.state.filter"
            [loading]="inHouseGridLoading">
  <ng-template kendoGridToolbarTemplate>
    <div class="k-grid-toolbar-button-display btn-web">
      <button kendoButton class="excel-button" icon="file-excel" [disabled]="loadingExcel" (click)="generateExcel()">
        {{inHouseTxt.exportToExcelLbl?inHouseTxt.exportToExcelLbl:inHouseGrid.exportToExcelLbl}}
        <kendo-loader *ngIf="loadingExcel"></kendo-loader>
      </button>
      <button kendoButton icon="file-pdf" class="pdf-button" [disabled]="loadingPDF" (click)="generatePDF()">
        {{inHouseTxt.exportToPdfLbl?inHouseTxt.exportToPdfLbl:inHouseGrid.exportToPdfLbl}}
        <kendo-loader *ngIf="loadingPDF"></kendo-loader>
      </button>
    </div>
    <input placeholder="Search in all columns..."
           kendoTextBox
           (input)="onFilterInHouseGrid($event.target.value)" class="pwaInHouseGridSearch" />
  </ng-template>

  <kendo-grid-column media="(max-width: 1024px)" title="In-House Quote Details">
    <ng-template kendoGridCellTemplate let-dataItem>
      <div class="row  mb-3">
        <div class="col-10 job-name">
          <span class="txt-bold" *ngIf="dataItem.jobNumber">{{dataItem.jobNumber}} - </span>{{dataItem.jobName}}
        </div>
        <div class="col-2 paddingZero textRight">
          <button class="k-button-print-command actionBtnCls" (click)="printMaterialProposal(dataItem)" [disabled]="dataItem.downloadInProgress"
                  *ngIf="dataItem.status && dataItem.status ==='Quote Sent'">
            <span class="k-icon k-i-print">
            </span>
          </button>
          <kendo-loader *ngIf="dataItem.downloadInProgress" style="color:blue"></kendo-loader>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-4 col-md-4 paddingZero">
          <span class="txt-bold">{{inHouseGrid.marketSegmentLbl}}:</span> <span class="float-right-pwa"> {{dataItem.marketSegment}}</span>
        </div>
        <div class="col-sm-4 col-md-4 paddingZero">
          <span class="txt-bold">{{inHouseGrid.revlbl}}:</span> <span class="float-right-pwa"> {{dataItem.revision}}</span>
        </div>
        <div class="col-sm-4 col-md-4 paddingZero">
          <span class="txt-bold">{{inHouseGrid.leedLbl}}:</span> <span class="float-right-pwa"> {{dataItem.leed ? "Y" : "N"}}</span>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-4 col-md-4 paddingZero">
          <span class="txt-bold">{{inHouseGrid.blastLbl}}:</span> <span class="float-right-pwa"> {{dataItem.blast ? "Y" : "N"}}</span>
        </div>
        <div class="col-sm-4 col-md-4 paddingZero">
          <span class="txt-bold">{{inHouseGrid.customerContactLbl}}:</span> <span class="float-right-pwa"> {{dataItem.customerContact}}</span>
        </div>
        <div class="col-sm-4 col-md-4 paddingZero">
          <span class="txt-bold">{{inHouseGrid.statusTextLbl}}:</span> <span class="float-right-pwa"> {{dataItem.statusReasonText}}</span>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-4 col-md-4 paddingZero">
          <span class="txt-bold">{{inHouseGrid.estimatorLbl}}:</span> <span class="float-right-pwa"> {{dataItem.estimatorEmail}}</span>
        </div>
        <div class="col-sm-4 col-md-4 paddingZero">
          <span class="txt-bold">{{inHouseGrid.quoteDateLbl}}:</span> <span class="float-right-pwa"> {{dataItem.quoteDateAsDate|date:'MM/dd/yyyy'}}</span>
        </div>

        <div class="col-sm-4 col-md-4 paddingZero">
          <span class="txt-bold">{{inHouseGrid.expirationDateLbl}}:</span> <span class="float-right-pwa"> {{dataItem.quoteExpirationDateAsDate|date:'MM/dd/yyyy'}}</span>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-4 col-md-4 paddingZero">
          <span class="txt-bold">{{inHouseGrid.statusLbl}}:</span> <span class="float-right-pwa"> {{dataItem.status}}</span>
        </div>

        <div class="col-sm-4 col-md-4 paddingZero">
          <span class="txt-bold">{{inHouseGrid.totalBaseBidLbl}}:</span> <span class="float-right-pwa">  {{dataItem.totalBaseBid | currency: dataItem.currencySymbol}}</span>
        </div>
        <div class="col-sm-4 col-md-4 paddingZero">
        </div>
      </div>
    </ng-template>
  </kendo-grid-column>


  <kendo-grid-column *ngFor="let col of gridSettings.columnsConfig"
                     [field]="col.field"
                     [title]="col.title"
                     [filter]="col.filter"
                     [filterable]="col.filterable"
                     [hidden]="col.hidden"
                     [format]="col.format" media="(min-width: 1025px)">
    <ng-template kendoGridFilterCellTemplate *ngIf="col.field == 'leed'">
      <app-grid-dropdown-filter [filter]="filter"
                                [data]="leeddata"
                                textField="name"
                                valueField="value">
      </app-grid-dropdown-filter>
    </ng-template>
    <ng-template kendoGridCellTemplate let-dataItem let-column="column" *ngIf="col.field == 'leed'">
      {{dataItem.leed ? "Y" : "N"}}
    </ng-template>
    <ng-template kendoGridFilterCellTemplate *ngIf="col.field == 'blast'">
      <app-grid-dropdown-filter [filter]="filter"
                                [data]="blastdata"
                                textField="name"
                                valueField="value">
      </app-grid-dropdown-filter>
    </ng-template>
    <ng-template kendoGridCellTemplate let-dataItem let-column="column" *ngIf="col.field == 'blast'">
      {{dataItem.blast ? "Y" : "N"}}
    </ng-template>
    <ng-template kendoGridFilterCellTemplate let-filter let-column="column" *ngIf="col.field == 'quoteDateAsDate'">
      <app-grid-daterange-filter class="date-range-filter"
                                 [filter]="filter"
                                 [field]="quoteDateAsDate">
      </app-grid-daterange-filter>
    </ng-template>
    <ng-template kendoGridFilterCellTemplate let-filter let-column="column" *ngIf="col.field == 'quoteExpirationDateAsDate'">
      <app-grid-daterange-filter class="date-range-filter"
                                 [filter]="filter"
                                 [field]="quoteExpirationDateAsDate">
      </app-grid-daterange-filter>
    </ng-template>
    <ng-template kendoGridCellTemplate let-column="column" let-dataItem *ngIf="col.field == 'totalBaseBid'">
      {{dataItem.totalBaseBid | currency: dataItem.currencySymbol}}
    </ng-template>
    <ng-template kendoGridFilterCellTemplate let-filter let-column="column" *ngIf="col.field == 'status'">
      <app-grid-dropdown-filter [filter]="filter"
                                [data]="statusData"
                                textField="name"
                                valueField="value">
      </app-grid-dropdown-filter>
    </ng-template>
  </kendo-grid-column>

  <!--<kendo-grid-column field="jobNumber"
                     title="{{inHouseGridColumnLbl.jobNumber}}"
                     [filterable]="true">
    <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
      <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
        <kendo-filter-contains-operator></kendo-filter-contains-operator>
      </kendo-grid-string-filter-cell>
    </ng-template>
  </kendo-grid-column>

  <kendo-grid-column field="revision"
                     title="{{inHouseGridColumnLbl.rev}}">
    <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
      <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
        <kendo-filter-contains-operator></kendo-filter-contains-operator>
      </kendo-grid-string-filter-cell>
    </ng-template>
  </kendo-grid-column>
  <kendo-grid-column field="jobName"
                     title="{{inHouseGridColumnLbl.jobName}}">
    <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
      <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
        <kendo-filter-contains-operator></kendo-filter-contains-operator>
      </kendo-grid-string-filter-cell>
    </ng-template>
  </kendo-grid-column>
  <kendo-grid-column field="leed"
                     title="{{inHouseGridColumnLbl.leed}}">
    <ng-template kendoGridFilterCellTemplate>
      <app-grid-dropdown-filter [filter]="filter"
                                [data]="leedData"
                                textField="name"
                                valueField="value">
      </app-grid-dropdown-filter>
    </ng-template>

    <ng-template kendoGridCellTemplate let-dataItem let-column="column">
      {{dataItem.leed ? "Y" : "N"}}
    </ng-template>
  </kendo-grid-column>
  <kendo-grid-column field="blast"
                     title="{{inHouseGridColumnLbl.blast}}">
    <ng-template kendoGridFilterCellTemplate>
      <app-grid-dropdown-filter [filter]="filter"
                                [data]="blastData"
                                textField="name"
                                valueField="value">
      </app-grid-dropdown-filter>
    </ng-template>
    <ng-template kendoGridCellTemplate let-dataItem let-column="column">
      {{dataItem.blast ? "Y" : "N"}}
    </ng-template>
  </kendo-grid-column>
  <kendo-grid-column field="marketSegment"
                     title="{{inHouseGridColumnLbl.marketSegment}}">
    <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
      <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
        <kendo-filter-contains-operator></kendo-filter-contains-operator>
      </kendo-grid-string-filter-cell>
    </ng-template>
  </kendo-grid-column>
  <kendo-grid-column field="quoteDateAsDate" filter="date" format="{0:d}"
                     title="{{inHouseGridColumnLbl.quoteDate}}" [width]="220">
    <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
      <app-grid-daterange-filter class="date-range-filter"
                                 [filter]="filter"
                                 field="quoteDateAsDate">
      </app-grid-daterange-filter>
    </ng-template>
  </kendo-grid-column>
  <kendo-grid-column field="quoteExpirationDateAsDate" filter="date" format="{0:d}"
                     title="{{inHouseGridColumnLbl.expiredDate}}" [width]="220">
    <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
      <app-grid-daterange-filter class="date-range-filter"
                                 [filter]="filter"
                                 field="quoteExpirationDateAsDate">
      </app-grid-daterange-filter>
    </ng-template>
  </kendo-grid-column>
  <kendo-grid-column field="totalBaseBid"
                     title="{{inHouseGridColumnLbl.totalBid}}">
    <ng-template kendoGridFilterCellTemplate let-filter let-column="column" let-dataItem>
      <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
        <kendo-filter-contains-operator></kendo-filter-contains-operator>
      </kendo-grid-string-filter-cell>
    </ng-template>
    <ng-template kendoGridCellTemplate let-column="column" let-dataItem>
      {{dataItem.totalBaseBid | currency: dataItem.currencySymbol}}
    </ng-template>
  </kendo-grid-column>
  <kendo-grid-column field="status"
                     title="{{inHouseGridColumnLbl.status}}">
    <ng-template kendoGridFilterCellTemplate let-filter let-column="column">-->
  <!--<kendo-grid-string-filter-cell [column]="column" [filter]="filter">
    <kendo-filter-contains-operator></kendo-filter-contains-operator>
  </kendo-grid-string-filter-cell>-->
  <!--<app-grid-dropdown-filter [filter]="filter"
                                [data]="statusData"
                                textField="name"
                                valueField="value">
      </app-grid-dropdown-filter>
    </ng-template>
  </kendo-grid-column>

  <kendo-grid-column field="customerContact"
                     title="{{inHouseGridColumnLbl.customerContact}}">
    <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
      <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
        <kendo-filter-contains-operator></kendo-filter-contains-operator>
      </kendo-grid-string-filter-cell>
    </ng-template>
  </kendo-grid-column>
  <kendo-grid-column field="statusReasonText"
                     title="{{inHouseGridColumnLbl.statusReasonText}}">
    <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
      <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
        <kendo-filter-contains-operator></kendo-filter-contains-operator>
      </kendo-grid-string-filter-cell>
    </ng-template>
  </kendo-grid-column>

  <kendo-grid-column field="estimatorEmail"
                     title="{{inHouseGridColumnLbl.estimatorEmail}}">
    <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
      <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
        <kendo-filter-contains-operator></kendo-filter-contains-operator>
      </kendo-grid-string-filter-cell>
    </ng-template>
  </kendo-grid-column>-->

  <kendo-grid-column title="{{inHouseTxt.printLbl?inHouseTxt.printLbl:inHouseGrid.printLbl}}" [resizable]="false" [width]="130" media="(min-width: 1025px)"s>
    <ng-template kendoGridCellTemplate class="d-super-center" let-dataItem>
      <!--Need to add *ngIf condition-->
      <button class="k-button actionBtnCls" (click)="printMaterialProposal(dataItem)" [disabled]="dataItem.downloadInProgress"
              *ngIf="dataItem.status && dataItem.status ==='Quote Sent'">
        <span class="k-icon k-i-print">
        </span>
      </button>
      <kendo-loader *ngIf="dataItem.downloadInProgress" style="color:blue"></kendo-loader>
    </ng-template>
  </kendo-grid-column>
  <ng-template kendoGridNoRecordsTemplate>
  </ng-template>
  <!--<ng-template kendoPagerTemplate let-totalPages="totalPages" let-currentPage="currentPage">
    <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
    <kendo-pager-numeric-buttons [buttonCount]="5"></kendo-pager-numeric-buttons>
    <kendo-pager-info></kendo-pager-info>
    <kendo-pager-next-buttons></kendo-pager-next-buttons>
    <kendo-pager-page-sizes [pageSizes]="[50,75,100]"></kendo-pager-page-sizes>
  </ng-template>
</kendo-grid>-->
<app-ca-prop></app-ca-prop>
